import { render, staticRenderFns } from "./SwapApply.vue?vue&type=template&id=b10db926&scoped=true"
import script from "./SwapApply.vue?vue&type=script&lang=js"
export * from "./SwapApply.vue?vue&type=script&lang=js"
import style0 from "./SwapApply.vue?vue&type=style&index=0&id=b10db926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10db926",
  null
  
)

export default component.exports